import React, { Component } from "react"
import Header from "./header"
class RegHeader extends Component {
  render() {
    return <Header />
  }
}

export default RegHeader
